<template>
  <div class="global_map">
    <!-- <i
      class="icon el-icon-location"
      @click="showMap"
      style="cursor:pointer;font-size: 20px;"
      title="设置经纬度"
    ></i> -->
    <!-- <el-button size="mini" type="success" @click="showMap" round
      >地图标绘经纬度</el-button
    > -->
    <div class="show-map-btn" @click="showMap">
      <span>
        <!-- <svg @click="removezfsb(item, index)" class="icon" aria-hidden="true">
          <use xlink:href="#iconbiaojidianwei" />
        </svg> -->
        <!-- <svg @click="showMap" class="icon" aria-hidden="true">
          <use xlink:href="#iconbiaojidianwei" />
        </svg> -->
        <svg  class="icon" aria-hidden="true">
          <use xlink:href="#iconbiaojidianwei" />
        </svg>
      </span>
      <!-- <span>地图标绘</span> -->
    </div>
    <el-dialog
      class="template"
      :visible.sync="dialogGlobalMapVisible"
      :before-close="closeMap"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div class="centermap_content">
        <div :id="globalmapId" class="globalmap"></div>
        <div class="latlng_content">
          <div class="input_content">
            <label>经度:</label>
            <el-input v-model="lngInput" readonly placeholder="经度"></el-input>
            <label>纬度:</label>
            <el-input v-model="latInput" readonly placeholder="纬度"></el-input>
          </div>
          <div class="btn_content">
            <el-button @click="cancle">取消</el-button>
            <el-button type="primary" @click="check">确认</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as L from 'leaflet'
import markerIcon from '@/assets/map/images/marker-icon.png'
require('@/extend/leaflet-extend.js')
export default {
  name: 'globalMap',
  components: {},
  props: {
    globalmapId: {
      default: () => ''
    },
    latlng: {
      default: () => []
    }
  },
  // wacth: {
  //   globalmapId: {
  //     immediate: true,
  //     handler: function (newValue, oldValue) {
  //       alert(11)
  //     },
  //     deep: true
  //   }
  // },
  data () {
    return {
      centerLat: 28.273886, // 初始地图中心经纬度坐标
      centerLng: 120.690968,
      latInput: '',
      lngInput: '',
      dialogGlobalMapVisible: false,
      map: {}
    }
  },
  methods: {
    showMap () {
      let _this = this
      if (this.latlng[0] === undefined || this.latlng[1] === undefined) { // 经纬度坐标存在空时，初始坐标
        this.latlng[0] = this.latlng[0] === undefined ? this.centerLng : this.latlng[0]
        this.latlng[1] = this.latlng[1] === undefined ? this.centerLat : this.latlng[1]
      }
      this.latInput = this.latlng[1] // 切换编辑，更新为当前经纬度坐标
      this.lngInput = this.latlng[0]
      this.dialogGlobalMapVisible = true
      _this.$nextTick(() => {
        _this.leaflet()
      })
      // this.latInput = this.latlng[1]
      // this.lngInput = this.latlng[0]
    },
    closeMap (done) {
      this.map.remove()
      done()
    },
    // 绘制地图
    leaflet () {
      let _this = this
      let blueIcon = L.icon({ iconUrl: markerIcon, iconSize: [25, 41], iconAnchor: [13, 21] })
      let map = L.CreateTianDiTuMap(_this.globalmapId, {
        crs: L.CRS.EPSG4490,
        zoomControl: false,
        minZoom: 8, // 最小缩放等级
        maxZoom: 18 // 最大缩放等级
      }).setView([this.latlng[1], this.latlng[0]], 12)
      let maker = L.marker([this.latlng[1], this.latlng[0]], { icon: blueIcon, draggable: true }).addTo(map)
      maker.on('dragend', (event) => {
        let latLng = maker.getLatLng()
        this.latInput = latLng.lat.toFixed(6)
        this.lngInput = latLng.lng.toFixed(6)
      })
      this.map = map
    },
    cancle () {
      this.$store.commit('globalLatLng', {})
      this.dialogGlobalMapVisible = false
      this.map.remove()
    },
    check () {
      // 将点击的地点经纬度通过Vuex传递到全局中，数据格式为{lat:num, lng:num}
      /**
       * 全局获取数据方式 this.$store.state.globalLatLng
       */
      // this.$store.commit('globalLatLng', { lat: this.latlng[1], lng: this.latlng[0] })
      this.map.remove()
      this.dialogGlobalMapVisible = false
      let lgtdlttd = { lat: this.latInput, lng: this.lngInput }
      this.$emit('changeAdd', lgtdlttd)
    }
  },
  mounted () { }
}
</script>
<style lang="less" scoped>
@import url("~@/assets/map/leaflet.css");
/deep/ .leaflet-control-container {
  .leaflet-bottom.leaflet-right {
    display: none;
  }
}
.global_map {
  position: absolute;
  right: -20px;
  top: 5px;
  .show-map-btn {
    // min-width: 120px;
    // height: 30px;
    padding: 0 10px;
    border-radius: 3px;
    // background: #3F6FFC;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    span {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: right;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      &:nth-of-type(1) {
        margin-right: 5px;
        .icon {
          font-size: 22px;
        }
      }
    }
  }
}
.centermap_content {
  .globalmap {
    width: 100%;
    height: 500px;
    position: relative;
    margin-bottom: 20px;
  }
  .latlng_content {
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    .input_content {
      width: 600px;
      height: 40px;
      float: left;
      label {
        height: 100%;
        line-height: 40px;
        float: left;
      }
      .el-input {
        width: 200px;
        margin-right: 20px;
        float: left;
      }
    }
    .btn_content {
      width: 200px;
      height: 40px;
      float: right;
      text-align: right;
    }
  }
}
</style>
